import { api } from 'common';

import { ORGANIZATION_ID_TO_ORIGIN } from './';

export const updateWindowHistory = (args: {
  pathname: string;
  organizationId: string;
  params: URLSearchParams | undefined;
  embedded: boolean | null;
}) => {
  const { pathname, organizationId, params, embedded } = args;
  if (embedded && params) {
    const filterParams: string[] = [];
    for (const [key, value] of params.entries()) {
      filterParams.push(`${key}=${value}`);
    }
    ORGANIZATION_ID_TO_ORIGIN[organizationId].forEach((origin) => {
      window.parent.postMessage({ filters: filterParams.join('&') }, origin);
    });
  }

  window.history.pushState({}, '', `#${pathname}?${params}`);
};

export const sortByDistance = (
  a: api.PrevisitProvider.SafeProviderWithPractices,
  b: api.PrevisitProvider.SafeProviderWithPractices,
) => {
  if (!a.practices[0].distance) {
    return 1;
  }
  if (!b.practices[0].distance) {
    return -1;
  }
  if (!a.practices[0].distance && !b.practices[0].distance) {
    return 0;
  }
  return a.practices[0].distance - b.practices[0].distance;
};

export const sortByName = (
  a: api.PrevisitProvider.SafeProviderWithPractices,
  b: api.PrevisitProvider.SafeProviderWithPractices,
) => {
  if (!a.lastName) {
    return -1;
  }
  if (!b.lastName) {
    return 1;
  }
  const lastNameA = a.lastName.toUpperCase();
  const lastNameB = b.lastName.toUpperCase();
  if (lastNameA < lastNameB) {
    return -1;
  }
  if (lastNameA > lastNameB) {
    return 1;
  }
  if (!a.firstName) {
    return -1;
  }
  if (!b.firstName) {
    return 1;
  }
  const firstNameA = a.firstName.toUpperCase();
  const firstNameB = b.firstName.toUpperCase();
  return firstNameA.localeCompare(firstNameB);
};

export const hasBackgroundInfo = (
  provider: api.PrevisitProvider.SafeProviderWithPractices,
) => {
  const hasEducation =
    !!provider.profile?.education && provider.profile?.education?.length > 0;
  const hasPositions =
    !!provider.profile?.positions && provider.profile?.positions?.length > 0;
  const hasCertifications =
    !!provider.profile?.certifications &&
    provider.profile?.certifications?.length > 0;
  const hasAwards =
    !!provider.profile?.awards && provider.profile?.awards?.length > 0;
  const hasProfessionalMemberships =
    !!provider.profile?.professionalMemberships &&
    provider.profile?.professionalMemberships?.length > 0;
  const hasSex = !!provider.sex;
  return {
    hasEducation,
    hasPositions,
    hasCertifications,
    hasAwards,
    hasProfessionalMemberships,
    hasSex,
  };
};
